export class SbrAutoCloseTime {
    constructor() {
        this.DeviceGuid = "";
        this.TimeInMiliseconds = 0;
        this.ResetOnCrossToOn = false;
    }
}
export class SbrAlarmLightDelay {
    constructor() {
        this.DeviceGuid = "";
        this.LightDelayInMiliseconds = 0;
    }
}
export class SbrAlarmLightDuration {
    constructor() {
        this.DeviceGuid = "";
        this.LightDurationInMiliseconds = 0;
    }
}
export class SbrServiceInfo {
    constructor() {
        this.StartsCount = 0;
        this.SafetyBarTrgCount = 0;
        this.PhotocelTrgCount = 0;
        this.InertionBreaksTrgCount = 0;
    }
}
//# sourceMappingURL=ISbrConfigService.js.map